import { useNavigationCapabilities } from '../hooks/useNavigationCapabilities';
import { useVisibilityPublicApi } from '../features/public-api/hooks/useVisibilityPublicApi';

// This is because hooks in React can't run conditionally (behind the gate) but components can
export const Capabilities = () => {
  useNavigationCapabilities();
  useVisibilityPublicApi();
  return null;
};